import GmapAutocomplete from './GmapAutocomplete.vue'
import GmapMap from './GmapMap.vue'
import GmapMarker from './GmapMarker.vue'
import { configureGoogleMapsLoader } from './googleMapsLoader'

const register = (app, name, component) => {
  app.component(name, component)
}

export default {
  install (app, options = {}) {
    configureGoogleMapsLoader(options)

    register(app, 'GmapMap', GmapMap)
    register(app, 'gmap-map', GmapMap)
    register(app, 'GmapMarker', GmapMarker)
    register(app, 'gmap-marker', GmapMarker)
    register(app, 'GmapAutocomplete', GmapAutocomplete)
    register(app, 'gmap-autocomplete', GmapAutocomplete)
  }
}
